export default __webpack_public_path__ + "static/media/NH009.00a3b4dd.jpg";